<template>
  <div class="box-container">
    <div
      class="info-item"
      v-for="item in infoList"
      :key="item.id"
      @click="handleDetail(item)"
    >
      <div class="header">
        <div class="source">
          {{ classifyList[Number(item.classifyId) - 1] }}
        </div>
        <p class="name" v-html="item.infoTitle"></p>
      </div>
      <div class="text-box" v-if="item.infoIntroduce">
        {{ item.infoIntroduce }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array
    }
  },
  data() {
    return {
      infoList: [],
      classifyList: ['通知公告', '行业动态', '政策文件', '报名指南', '考培资源']
    }
  },
  watch: {
    list(val) {
      this.infoList = val
    }
  },
  mounted() {
    this.infoList = this.list
  },
  methods: {
    handleDetail(row) {
      const { classifyId, id } = row
      if (!(classifyId && id)) return
      this.$router.push({
        path: '/publicInformationDetail',
        query: { classifyId, id, name: this.$route.query.searchValue }
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.box-container {
  .info-item {
    width: 100%;
    border-bottom: 1px dashed rgba(181, 181, 181, 0.35);
    padding: 30px 0;
    cursor: pointer;
    &:hover {
      background-color: rgba(27, 134, 255, 0.07);
    }
    .header {
      display: flex;
      align-items: center;
      .source {
        padding: 5px 10px;
        color: #fff;
        font-size: 12px;
        font-weight: bold;
        background: linear-gradient(90deg, #0751b5 0%, #507cf7 100%);
        border-radius: 50px;
      }
      .name {
        width: 900px;
        color: #333;
        font-weight: bold;
        font-size: 16px;
        margin-left: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
    }
    .text-box {
      width: 900px;
      margin-top: 20px;
      color: #666;
      font-size: 14px;
      line-height: 24px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
  }
}
</style>
